import * as React from 'react';
import { Link } from '@reach/router';
import { Breadcrumb, Col, Row, Layout } from '@nackle/paper';
const { Header } = Layout;
import { Home3 } from '@nackle/icons';

// paths
import { PATH, PATH_CREATE, PATH_UPDATE } from 'routes/paths';

//styles
import './versions-nav.less';

class VersionsNav extends React.Component {
    getBreadcrumbs = () => {
        const { path, companyId } = this.props;
        switch ( path ) {
            case PATH:
                return (
                    <Breadcrumb.Item>
                        <Home3/>
                        <span>Privacy - Version History</span>
                    </Breadcrumb.Item>
                );
            case PATH_UPDATE:
                return (
                    <React.Fragment>
                        <Breadcrumb.Item>
                            <Home3/>
                            <Link to={ `/${ companyId }` }>
                                <span>Privacy - Version History</span>
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>Update Version</span>
                        </Breadcrumb.Item>
                    </React.Fragment>
                );
            case PATH_CREATE:
                return (
                    <React.Fragment>
                        <Breadcrumb.Item>
                            <Home3/>
                            <Link to={ `/${ companyId }` }>
                                <span>Privacy - Version History</span>
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>Create Version</span>
                        </Breadcrumb.Item>
                    </React.Fragment>
                );
            default:
                return [];
        }
    };
    render() {
        return (
            <div className="versions-nav-wrapper">
                <Row>
                    <Col>
                        <Header className="page-header">
                            <Row align="middle">
                                <Col flex={ 1 }>
                                    <Breadcrumb>{ this.getBreadcrumbs() }</Breadcrumb>
                                </Col>
                            </Row>
                        </Header>

                    </Col>
                    <Col>
                        { this.props.path === PATH_UPDATE ||
                            ( this.props.path === PATH_CREATE && (
                                <Link to="/" className="versions-list-link">
                                    Back to Version History
                                </Link>
                            ) ) }
                    </Col>
                </Row>
            </div>
        );
    }
}

export default VersionsNav;
